import { Record } from 'immutable';
import { schema } from 'normalizr';

export const WarrantyFee = new Record({
  id: undefined,
  reason: undefined,
  fee: undefined,
  obsolete: undefined,
});

export const warrantyFeeSchema = new schema.Entity('warrantyFees');

// for reading in nested models, object with { field: schema }
// warrantyFeeSchema.define({  });
